import { useContext, useEffect, useRef, useState } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import Navbar from "./Navbar";
import Sidebar from "./Sidebar";
import { setScrollY } from "../../../redux/scrollSlice";
import { useDispatch } from "react-redux";
import { AuthContext } from "context/AuthContext";
import { toast } from "react-toastify";
const MainLayout = () => {
  const navigate = useNavigate();
  const [sideOpen, setSideOpen] = useState(true);
  const currentUrl = useState(window.location.href);
  const { datauser } = useContext(AuthContext);
  const [admin, setAdmin] = useState(false);
  const [hasPermission, setHasPermission] = useState(false);

  const scrollContainerRef = useRef();
  const dispatch = useDispatch();

  useEffect(() => {
    // Mengakses URL saat ini
    const currentURL = window.location.href;
    // Memeriksa apakah URL mengandung "administrator"
    if (currentURL.includes("administrator")) {
      setAdmin(true);
    } else {
      setAdmin(false);
    }
  }, [currentUrl]);

  useEffect(() => {
    if (datauser) {
      const permissions = datauser.group_permissions;
      if (
        permissions.includes("access_menu_agent") ||
        permissions.includes("access_menu_admin")
      ) {
        setHasPermission(true);
      } else {
        toast.warning(
          "Sorry, you don't have permission to perform this action.",
          {
            position: "top-center",
            autoClose: true,
            autoClose: 2000,
            hideProgressBar: true,
            closeOnClick: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          }
        );
        navigate("/");
      }
    }
  }, [datauser]);

  useEffect(() => {
    if (!hasPermission) {
      return;
    }

    const scrollContainer = scrollContainerRef.current;

    if (scrollContainer) {
      // Membaca nilai scroll Y pada elemen
      const handleScroll = () => {
        const newScrollY = scrollContainer.scrollTop;
        dispatch(setScrollY(newScrollY));
      };

      scrollContainer.addEventListener("scroll", handleScroll);

      return () => {
        scrollContainer.removeEventListener("scroll", handleScroll);
      };
    }
  }, [hasPermission]);

  return (
    <div className="flex h-screen overflow-auto text-neutral-700 dark:text-neutral-200">
      <Sidebar admin={admin} sideOpen={sideOpen} setSideOpen={setSideOpen} />
      <div
        className={`relative flex flex-col flex-1 overflow-y-auto overflow-x-hidden custom-scroll ${
          !sideOpen ? "sm:pl-14" : ""
        }`}
      >
        <Navbar
          admin={admin}
          setAdmin={setAdmin}
          sideOpen={sideOpen}
          setSideOpen={setSideOpen}
        />
        <div
          ref={scrollContainerRef} // Mengaitkan elemen dengan useRef
          className="h-screen w-full mx-auto overflow-y-auto overflow-x-hidden custom-scroll-content bg-neutral-200 dark:bg-neutral-900"
        >
          <div className="min-h-full">
            <Outlet />
          </div>
          <div className="h-10 flex items-center px-8 text-sm bg-neutral dark:bg-neutral-800 text-neutral-500">
            Copyright © 2023 . All rights reserved.
          </div>
        </div>
      </div>
    </div>
  );
};

export default MainLayout;
